
import React, { useState } from "react";
import { Button, Tooltip } from "reactstrap";

function ButtonWithToopltip({ tooltipLabel, icon, onClickAction, targetId }) {
  //new addition
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  return (
    <Button

      onClick={onClickAction}
      id={targetId}
      className="rounded-circle btn-primary d-flex align-items-center justify-content-center"
      style={{
        width: "40px",
        height: "40px",
        fontSize: "15px",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <i className={`fa-solid ${icon}`}></i>
      <Tooltip
        placement="bottom"
        isOpen={tooltipOpen}
        target={targetId}
        toggle={toggleTooltip}
        popperClassName="custom-tooltip"
        innerClassName="custom-tooltip-inner"
      >
        {tooltipLabel}
      </Tooltip>
    </Button>
  );
}

export default ButtonWithToopltip;
